import { render, staticRenderFns } from "./TestBadge.vue?vue&type=template&id=003f1ab7&scoped=true&"
import script from "./TestBadge.vue?vue&type=script&lang=js&"
export * from "./TestBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f1ab7",
  null
  
)

export default component.exports